import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]
  selectedItems() {
    var selectLists = this.selectTargets;
    for (let i = 0; i < selectLists.length; i++) {
      selectLists[i].tomselect.clear();
    }
  }
}
